module.exports = __webpack_public_path__ + "static/media/PS-02.572dd2e2.svg";